// extracted by mini-css-extract-plugin
export var container = "IntroProductModal_container__0UGWP";
export var disclaimer = "IntroProductModal_disclaimer__5vwhd";
export var fontNunitoSans = "'Nunito Sans'";
export var fontPlayfair = "'PlayFair Display'";
export var shared = "'../shared.module.css'";
export var sm = "576px";
export var subtitle = "IntroProductModal_subtitle__48wjZ";
export var textContainer = "IntroProductModal_textContainer__mLC3Q";